export const navPrices = () => {

    const navPricesContainer = document.querySelectorAll('.nav-prices-block');

    if (navPricesContainer) {

        navPricesContainer.forEach(container => {

            const select = container.querySelector('select');

            if (select) {
                select.addEventListener('change', (e) => {
                    const classValue = e.target.value;
                    const values = container.querySelectorAll('.nav-prices--value');
                    values.forEach(value => {
                        if (value.dataset.class === classValue) {
                            value.classList.add('is-showing');
                        } else {
                            value.classList.remove('is-showing');
                        }
                    });
                });
            }
        });
    }
}